import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FunctionalityCard, Typography } from '../../../../components';
import { IconLoading } from '../../../../icons';
import type { Filters, NewsForm } from '../../../../imports/types';
import { useAppSelector } from '../../../../redux/hooks';

/* tokencreator imports */

type NewsListProps = {
  news: NewsForm[];
  isLoading: boolean;
  // handleShowSidebar: (type: SidebarType, optionalProps?: any) => void;
  filtersState: {
    [key: string]: {
      filter: Filters;
      value: any;
    };
  };
  orderBy: {
    type: string;
    direction: string;
  };
};
const NewsList = ({ news, isLoading, filtersState, orderBy }: NewsListProps) => {
  const { t } = useTranslation(['tokenCreator']);
  const navigate = useNavigate();
  const { workspace } = useAppSelector((user) => user.team);
  const handleGoToNewsDetails = (newsId: String) => {
    navigate(`news/${newsId}`);
  };

  return !isLoading ? (
    <>
      <Typography size="body-semibold-20">{t('collection.title_news')}</Typography>
      <div className="flex flex-wrap gap-5">
        {news.length ? (
          news.map((item, index) => {
            return (
              <div className="cursor-pointer" key={`${item.id}-${index}`}>
                <FunctionalityCard
                  functionality={item}
                  key={item.id}
                  hasWritePermission={workspace?.permissions.token_creator.write}
                  onClick={() => handleGoToNewsDetails(item.id)}
                />
              </div>
            );
          })
        ) : (
          <div className="col-span-full mt-6 text-center">
            <Typography>
              {t(
                news.length === 0 ? 'collection.no_news_found' : 'collection.no_filtered_news_found'
              )}
            </Typography>
          </div>
        )}
      </div>
    </>
  ) : (
    <div className="flex grow items-center justify-center">
      <IconLoading className="size-12 animate-spin text-primary-500" />
    </div>
  );
};

export default NewsList;
